import { render, staticRenderFns } from "./widget-payroll.vue?vue&type=template&id=4b4de2b2&"
import script from "./widget-payroll.vue?vue&type=script&lang=js&"
export * from "./widget-payroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports